import businessClient from 'src/services/clients/business'

import { IMeta, ILocation, ISetLocation } from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: { url: '', endpoint: '' } }
const ILocationsResponse = { meta: IMeta, data: { list: [ILocation] } }
const ISetLocationResponse = { meta: IMeta, data: { update: [ISetLocation] } }

export const integrationGoodtill = {
  /**
   *@param {{ subdomain: string, username: string, password: string }} data
   * @return {Promise<IResponse>}
   */
  pairSystem(data, signal) {
    return businessClient().post('apppair/goodtill/pair/business', { data }, { signal })
  },

  /**
   * @return {Promise<ILocationsResponse>}
   */
  locationsList(signal) {
    return businessClient().post('apppair/goodtill/location/portal/list', {}, { signal })
  },

  /**
   * @param {{ store_id: number, goodtill_store_id: string, goodtill_store_name: string }} data
   * @return {Promise<ISetLocationResponse>}
   */
  pairStore(data, signal) {
    return businessClient().post('apppair/goodtill/pair/store', { data }, { signal })
  },

  /**
   * @return {Promise<IResponse>}
   */
  disconnect(signal) {
    return businessClient().post('apppair/goodtill/disconnect/business', {}, { signal })
  },

  /**
   * @return {Promise<IResponse>}
   */
  getCatalogue(signal) {
    return businessClient().post('apppair/goodtill/get-catalogue', {}, { signal })
  },

  /**
   * @return {Promise<IResponse>}
   */
  getBranches(signal) {
    return businessClient().post('apppair/goodtill/outlet', {}, { signal })
  },

  /**
   *  @param {{ store_id: number}} filter
   * @return {Promise<IResponse>}
   */
  disconnectStore(filter, signal) {
    return businessClient().post('apppair/goodtill/disconnect/store', { filter }, { signal })
  },
}
